import httpClient, { ApiResponse } from "./httpClient";

export const createTick = async (body: any): Promise<ApiResponse<any>> =>
  httpClient.post(`/ticks/create/action`, body);

export const deleteTick = async (tickId: string): Promise<ApiResponse<any>> =>
  httpClient.delete(`/ticks/destroy/${tickId}`);